
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/david-crane",
      function () {
        return require("private-next-pages/david-crane.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/david-crane"])
      });
    }
  